import React from 'react'

import ChecklistFiltersList from '../checklists/filters/ChecklistFiltersList'
import PlaceFiltersList from '../places/filters/PlaceFiltersList'
import ServiceOrderFiltersList from '../serviceOrders/filters/ServiceOrderFiltersList'
import UserFiltersList from '../users/filters/UserFiltersList'

const DynamicFiltersList = ({ type, ...props }) => {
  if (type.startsWith('user')) return <UserFiltersList {...props} />
  if (type.startsWith('service_order')) {
    return <ServiceOrderFiltersList {...props} isKanban={true} />
  }
  if (type.startsWith('checklist')) return <ChecklistFiltersList {...props} />
  if (type.startsWith('place')) return <PlaceFiltersList {...props} />

  return false
}

export default DynamicFiltersList
